
enum relaAlarmInitialize {
  areaName = "backsearch_curAreaName",
  areaId = "backsearch_region_id",
  appId = "backsearch_system_id",
  deviceType = "backsearch_deviceType"
}
enum continuingInitialize {
  areaId = "n_areaId",//区域
  appId = "s_appId",//应用
  deviceType = "n_deviceId",//设备
  areaName = "s_areaName"//区域名称
}

enum homeInitialize {
  areaId = "n_areaId",//区域
  appId = "s_appId",//应用
  deviceType = "n_deviceId",//设备
  areaName = "s_areaName"//区域名称
}

export {
  relaAlarmInitialize,
  continuingInitialize,
  homeInitialize
}


// WEBPACK FOOTER //
// ./src/ts/Enum/routeInitialize.ts